/**
 * Created by Florin David on 04/04/2017.
 */
import { v4 } from 'uuid'

import localStorage from './local-storage'

let browserSessionId = localStorage.get('browserSessionId')

if (!browserSessionId) {
  browserSessionId = v4()
  localStorage.set('browserSessionId', browserSessionId)
}

/**
 * Get browser session id from local storage or create new one and save it if not found
 */
export default browserSessionId as string
